module.exports = __webpack_public_path__ + "media/demo.7f10c4e3.mp4";